(function () {
  // ==== CONFIG HELPERS ====
  function getConfig() {
    return window.deluxeGiftConfig || {};
  }

  function getThresholdCents() {
    var cfg = getConfig();
    var t = cfg.thresholdCents;
    return typeof t === 'number' ? t : 75 * 100;
  }

  function getVariantId() {
    var cfg = getConfig();
    return cfg.variantId || null;
  }

  function getExclusionTags() {
    var cfg = getConfig();
    return Array.isArray(cfg.exclusionTags) ? cfg.exclusionTags : [];
  }

  function getBlockingProductIds() {
    var cfg = getConfig();
    return Array.isArray(cfg.blockingProductIds) ? cfg.blockingProductIds : [];
  }

  // Prevent double-adds
  var deluxeGiftIsAdding = false;

  // Track last cart state so we can tell if the user removed the gift manually
  var lastCartHadGift = false;

  // Session-based opt-out flag
  var deluxeGiftOptedOut =
    (typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem('deluxeGiftOptedOut') === 'true');

  // Debug: turn this on in console: window.DELUXE_GIFT_DEBUG = true;
  window.DELUXE_GIFT_DEBUG = window.DELUXE_GIFT_DEBUG || false;

  function log() {
    if (window.DELUXE_GIFT_DEBUG && typeof console !== 'undefined') {
      console.log.apply(console, ['[DeluxeGift]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  if (window.deluxeGiftAutoAddBound) return;
  window.deluxeGiftAutoAddBound = true;

  function setOptOut(value) {
    deluxeGiftOptedOut = value;
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('deluxeGiftOptedOut', value ? 'true' : 'false');
    }
    log('Opt-out set to:', value);
  }

  function normaliseTag(tag) {
    return (tag || '').toString().toLowerCase().trim();
  }

  function customerHasExcludedTag() {
    try {
      var tags = Array.isArray(window.customerTags) ? window.customerTags : [];
      var customerTagsNorm = tags.map(normaliseTag);

      var exclusionNorm = getExclusionTags()
        .map(normaliseTag)
        .filter(function (t) { return t.length; });

      var hasTag = exclusionNorm.some(function (exTag) {
        return customerTagsNorm.indexOf(exTag) !== -1;
      });

      var hasLocalFlag = false;
      if (typeof localStorage !== 'undefined') {
        hasLocalFlag = localStorage.getItem('deluxeGift_excluded_flag') === 'true';
      }

      return hasTag || hasLocalFlag;
    } catch (e) {
      return false;
    }
  }

  // Does the cart contain any of the blocking products?
  function cartHasBlockingProduct(cart) {
    var rawIds = getBlockingProductIds();
    if (!rawIds.length) return false;

    var blockIds = rawIds
      .map(function (id) { return Number(id); })
      .filter(function (id) { return !!id; });

    if (!blockIds.length) return false;

    return cart.items.some(function (item) {
      return blockIds.indexOf(item.product_id) !== -1;
    });
  }

  function fetchCart() {
    log('Fetching cart…');
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function addGiftToCart() {
    var variantId = getVariantId();

    if (!variantId) {
      log('No DELUXE_VARIANT_ID configured, skipping add.');
      return Promise.resolve();
    }

    if (deluxeGiftIsAdding) {
      log('Already adding gift, skipping second add');
      return Promise.resolve();
    }

    deluxeGiftIsAdding = true;
    log('Adding gift to cart…');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      credentials: 'same-origin',
      body: new URLSearchParams({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        log('Gift added:', data);
        refreshUpCart();
      })
      .catch(function (e) {
        log('Error adding gift', e);
      })
      .finally(function () {
        deluxeGiftIsAdding = false;
      });
  }

  function removeGiftFromCart(lineKey) {
    log('Removing gift from cart…');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      credentials: 'same-origin',
      body: new URLSearchParams({ id: lineKey, quantity: 0 })
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      log('Gift removed:', data);
      refreshUpCart();
    }).catch(function (e) {
      log('Error removing gift', e);
    });
  }

  function getSubtotalExcludingGift(cart) {
    var variantId = getVariantId();
    var variantIdAsNumber = variantId ? Number(variantId) : null;

    var subtotal = cart.items.reduce(function (sum, item) {
      if (variantIdAsNumber && item.variant_id === variantIdAsNumber) return sum;

      var line = typeof item.final_line_price === 'number'
        ? item.final_line_price
        : item.line_price;

      return sum + line;
    }, 0);

    log('Subtotal ex gift (cents):', subtotal);
    return subtotal;
  }

  function refreshUpCart() {
    if (typeof window.upcartRefreshCart === 'function') {
      log('Calling upcartRefreshCart()');
      window.upcartRefreshCart();
    }
  }

  function applyDeluxeGiftRule() {
    fetchCart().then(function (cart) {
      log('Cart fetched:', cart);

      var thresholdCents = getThresholdCents();
      var variantId = getVariantId();
      var variantIdAsNumber = variantId ? Number(variantId) : null;

      var subtotalExGift = getSubtotalExcludingGift(cart);
      var hasExcludedTag = customerHasExcludedTag();
      var hasBlockingProduct = cartHasBlockingProduct(cart);

      var giftLine = null;

      if (variantIdAsNumber) {
        cart.items.forEach(function (item, idx) {
          if (item.variant_id === variantIdAsNumber) {
            giftLine = item;
            log('Found gift at index', idx, 'key', item.key, 'qty', item.quantity);
          }
        });
      }

      var baseShouldHaveGift =
        subtotalExGift >= thresholdCents &&
        !hasExcludedTag &&
        !hasBlockingProduct;

      log(
        'Base rule → baseShouldHaveGift?',
        baseShouldHaveGift,
        'optedOut?',
        deluxeGiftOptedOut,
        'hasBlockingProduct?',
        hasBlockingProduct
      );

      // Detect manual opt-out
      if (!deluxeGiftOptedOut && lastCartHadGift && !giftLine && baseShouldHaveGift) {
        log('Detected manual removal while eligible → opting out for this session');
        setOptOut(true);
      }

      var shouldHaveGift = baseShouldHaveGift && !deluxeGiftOptedOut;

      log('Final rule → shouldHaveGift?', shouldHaveGift, 'giftLine?', !!giftLine);

      if (shouldHaveGift && !giftLine) {
        addGiftToCart();
      }

      if (!shouldHaveGift && giftLine) {
        removeGiftFromCart(giftLine.key);
      }

      lastCartHadGift = !!giftLine;
    }).catch(function (e) {
      log('Error fetching cart', e);
    });
  }

  // Expose globally so you can call it from console or other scripts
  window.checkDeluxeGift = applyDeluxeGiftRule;

  document.addEventListener('DOMContentLoaded', function () {
    applyDeluxeGiftRule();
    setInterval(applyDeluxeGiftRule, 4000);
  });
})();
